import { ButtonExit } from './styles';

export function ButtonExitFooter({ onClick }) {
  return <ButtonExit onClick={onClick}>Cancelar</ButtonExit>;
}
